import { render, staticRenderFns } from "./TextareaRich.vue?vue&type=template&id=04cc0d37"
import script from "./TextareaRich.vue?vue&type=script&lang=js"
export * from "./TextareaRich.vue?vue&type=script&lang=js"
import style0 from "./TextareaRich.vue?vue&type=style&index=0&id=04cc0d37&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports